export default function vault(store){
	return {
		get(key = null) {
			if(key){
				return store.getters['vault/get'](key)
			}else{
				return store.getters['vault/list']
			}

		},
		set(key, value) {
			store.dispatch('vault/set', { key, value })
			return value;
		}
	}
};
